<template>
  <card class="card-stats" :show-footer-line="true">
    <b-row>

      <b-col md="5" class="pr-0 wrap-container" v-if="$slots.icon || icon">
        <slot name="icon">
            <img class="img-fluid" :src="icon">
        </slot>
      </b-col>

      <b-col md="7" class="wrap-container">
        <slot>
          <h2 class="card-title text-uppercase text-muted mb-0" v-if="title">{{title}}</h2>
          <p class="mb-0" v-if="subTitle">{{subTitle}}</p>
        </slot>
      </b-col>

    </b-row>

    <p class="mt-3 mb-0 text-sm">
      <slot name="footer">

      </slot>
    </p>
  </card>
</template>
<script>
  import Card from './Card.vue';

  export default {
    name: 'stats-card',
    components: {
      Card
    },
    props: {
      type: {
        type: String,
        default: 'primary'
      },
      icon: String,
      title: String,
      subTitle: String,
      iconClasses: [String, Array]
    }
  };
</script>
<style scope>
.card-stats p{
  font-size: 15px;
  color: #112357 !important;
  line-height: 1 !important;
}
.card-stats h2{
  color: #112357 !important;
  font-weight: bold;
  font-size: 50px;
  line-height: 1;
}
.card-stats .wrap-container{
  align-self: center;
}
@media (max-width: 1600px) {
  .card-stats p{
    font-size: 12px;
  }
  .card-stats h2{
    font-size: 40px;
  }
}

</style>
